import type { DeleteTeamReferenceStoryPayload } from '@rhythmic/types'
import { DeleteTeamReferenceStorySchema } from '@rhythmic/types'
import { useRhythmicLogger } from '#imports'

import { getTeamReferenceStoryCollection } from '../../getCollections'

const logger = useRhythmicLogger('useTeamContext:deleteReferenceStory')

export interface DeleteReferenceStoryContext {
  teamId: string
}

export default function handleDeleteReferenceStory(
  payload: DeleteTeamReferenceStoryPayload,
  context: DeleteReferenceStoryContext,
): Transaction {
  try {
    const parsed = DeleteTeamReferenceStorySchema.parse(payload)
    const { teamId } = context

    if (!teamId) {
      const error = new Error('Team context is not ready')
      logger.error('Unable to delete reference story: missing team identifier')
      throw error
    }

    const collection = getTeamReferenceStoryCollection(teamId)
    const transaction = collection.delete(parsed.id)

    logger.debug('Reference story deleted via collection', {
      teamId,
      id: parsed.id,
    })
    return transaction
  } catch (error) {
    logger.error('deleteReferenceStory failed', { payload, error })
    if (error instanceof Error) throw error
    throw new Error('Failed to delete reference story')
  }
}
